
import React from "react";
import {
    Globe,
    Package,
    ShieldCheck,
    Truck,
    BadgeCheck,
    ArrowRight,
} from "lucide-react";

const WhyChefco = () => {
    return (

        <div className="min-h-screen bg-[#F4F8F4] text-[#2C3E2B] overflow-hidden">

            {/* ================= HERO SECTION ================= */}

            <section className="relative overflow-hidden bg-gradient-to-br from-[#121E12] via-[#2C3E2B] to-[#1C2C1C]">

                {/* Background Blurs */}
                <div className="absolute top-[-120px] left-[-120px] w-[420px] h-[420px] bg-[#88A77D]/20 rounded-full blur-3xl"></div>

                <div className="absolute bottom-[-150px] right-[-120px] w-[420px] h-[420px] bg-[#C86A4B]/15 rounded-full blur-3xl"></div>

                <div className="max-w-[1700px] mx-auto px-5 lg:px-8 py-16 lg:py-24 relative z-10">

                    <div className="grid lg:grid-cols-2 gap-14 items-center">

                        {/* LEFT CONTENT */}
                        <div>

                            {/* Badge */}
                            <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-xl border border-white/10 rounded-full px-5 py-3">

                                <div className="w-2.5 h-2.5 rounded-full bg-[#C86A4B] animate-pulse"></div>

                                <span className="text-sm font-semibold text-white tracking-wide">
                                    Global Hospitality Supply & Logistics
                                </span>

                            </div>

                            {/* Heading */}
                            <h1 className="mt-7 text-4xl md:text-5xl lg:text-7xl font-black leading-[1.1] tracking-tight text-white">

                                Why
                                <span className="bg-gradient-to-r from-[#C86A4B] to-[#E28A6B] bg-clip-text text-transparent">
                                    {" "}ChefCo?
                                </span>

                            </h1>

                            {/* Description */}
                            <p className="mt-8 text-lg leading-8 text-white/85 max-w-2xl">

                                CHEFCO Hospitality Partners LLP is an India-born supply and logistics enterprise dedicated to elevating foodservice operations globally. We specialize in the sourcing, marketing, and systematic distribution of premium food products and custom packaging solutions—including tailored takeout containers, napkins, paper bags, and PET bottles—for restaurants, healthcare facilities, educational institutions, and major entertainment venues.
                                Our foundation is built on a profound multi-generational legacy: we carry forward a 40-year family heritage in the retail grocery business, combining decades of deep-rooted market understanding with modern logistics. Driven by a seasoned team of former professional chefs with deep roots in the Indian and Canadian hospitality sectors, we possess firsthand understanding of kitchen and inventory demands.
                                Through our dedicated Canadian arm, ToGo Packaging Solutions in Ottawa, we bridge international supply chains to deliver seamless, reliable, and highly efficient service. At CHEFCO, we don't just supply; we streamline your operations with an unwavering focus on food safety, rigorous hygiene, and systematic supply chains.

                            </p>



                            {/* CTA */}
                            <div className="flex flex-wrap gap-4 mt-10">

                                <button className="bg-[#C86A4B] hover:bg-[#b85d42] hover:-translate-y-0.5 transition-all duration-300 px-8 py-4 rounded-2xl text-white font-bold shadow-xl flex items-center gap-2">

                                    Explore Solutions

                                    <ArrowRight className="w-5 h-5" />

                                </button>

                                <button className="bg-white/10 backdrop-blur-xl border border-white/20 hover:bg-white/20 hover:-translate-y-0.5 transition-all duration-300 px-8 py-4 rounded-2xl text-white font-bold">

                                    Contact Our Team

                                </button>

                            </div>

                        </div>

                        {/* RIGHT CARD */}
                        <div className="relative">

                            <div className="bg-white/5 backdrop-blur-xl rounded-[40px] p-6 lg:p-8 shadow-2xl border border-white/10">

                                {/* Video */}
                                <div className="relative rounded-[28px] overflow-hidden h-[320px] shadow-lg">

                                    <video
                                        src="https://player.vimeo.com/external/200866977.hd.mp4?s=71e3bc8310e9f1a307fe6cb621845155269e77ad&profile_id=119"
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                        className="w-full h-full object-cover"
                                    />

                                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>

                                    {/* Floating Card */}
                                    <div className="absolute bottom-5 left-5 right-5">

                                        <div className="bg-white/95 backdrop-blur-md rounded-2xl p-4 shadow-xl border border-white/25 flex items-center gap-3">

                                            <div className="w-2.5 h-2.5 rounded-full bg-emerald-500 animate-ping"></div>

                                            <div>

                                                <p className="text-[10px] text-[#556B53] font-bold uppercase tracking-wider">
                                                    Active Supply Bridge
                                                </p>

                                                <h3 className="text-xl font-black text-[#2C3E2B] mt-0.5">
                                                    India ↔ Canada
                                                </h3>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                {/* Features */}
                                <div className="grid grid-cols-2 gap-4 mt-5">

                                    <div className="bg-[#EAF2EA] rounded-3xl p-5 border border-[#D5E2D5] hover:-translate-y-1 transition duration-300">

                                        <Package className="w-7 h-7 text-[#C86A4B]" />

                                        <h3 className="text-lg font-black text-[#2C3E2B] mt-4">
                                            Custom Packaging
                                        </h3>

                                        <p className="text-sm text-[#556B53] mt-2 leading-relaxed">
                                            Tailored food-safe takeaway packaging solutions.
                                        </p>

                                    </div>

                                    <div className="bg-[#EAF2EA] rounded-3xl p-5 border border-[#D5E2D5] hover:-translate-y-1 transition duration-300">

                                        <Truck className="w-7 h-7 text-[#88A77D]" />

                                        <h3 className="text-lg font-black text-[#2C3E2B] mt-4">
                                            Fast Logistics
                                        </h3>

                                        <p className="text-sm text-[#556B53] mt-2 leading-relaxed">
                                            Streamlined delivery & inventory operations.
                                        </p>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* ================= CORE VALUES ================= */}

            <section className="py-20 bg-[#F4F8F4]">

                <div className="max-w-[1700px] mx-auto px-5 lg:px-8">

                    {/* Section Header */}
                    <div className="text-center max-w-3xl mx-auto">

                        <span className="bg-[#2C3E2B]/10 text-[#2C3E2B] text-xs font-bold uppercase tracking-[0.25em] px-5 py-3 rounded-full">

                            OUR STRENGTH

                        </span>

                        <h2 className="text-4xl md:text-5xl font-black text-[#1E2D1E] mt-7 tracking-tight">

                            Built By Hospitality Professionals

                        </h2>

                        <p className="text-[#556B53] mt-5 leading-8 text-lg">

                            Our leadership team consists of former professional chefs
                            and hospitality experts with deep operational experience
                            across India and Canada.

                        </p>

                    </div>

                    {/* Cards */}
                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">

                        {/* Card */}
                        <div className="bg-white rounded-[32px] p-7 border border-[#E2ECE2] shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300">

                            <div className="w-14 h-14 rounded-2xl bg-[#EAF2EA] text-[#2C3E2B] flex items-center justify-center">

                                <ShieldCheck className="w-7 h-7" />

                            </div>

                            <h3 className="text-2xl font-black text-[#2C3E2B] mt-6">
                                Food Safety
                            </h3>

                            <p className="text-[#556B53] leading-7 mt-4">
                                Rigorous hygiene standards and food-grade certified materials.
                            </p>

                        </div>

                        {/* Card */}
                        <div className="bg-white rounded-[32px] p-7 border border-[#E2ECE2] shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300">

                            <div className="w-14 h-14 rounded-2xl bg-[#EAF2EA] text-[#C86A4B] flex items-center justify-center">

                                <Globe className="w-7 h-7" />

                            </div>

                            <h3 className="text-2xl font-black text-[#2C3E2B] mt-6">
                                Global Reach
                            </h3>

                            <p className="text-[#556B53] leading-7 mt-4">
                                International sourcing and supply chain integration.
                            </p>

                        </div>

                        {/* Card */}
                        <div className="bg-white rounded-[32px] p-7 border border-[#E2ECE2] shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300">

                            <div className="w-14 h-14 rounded-2xl bg-[#EAF2EA] text-[#C86A4B] flex items-center justify-center">

                                <BadgeCheck className="w-7 h-7" />

                            </div>

                            <h3 className="text-2xl font-black text-[#2C3E2B] mt-6">
                                Verified Quality
                            </h3>

                            <p className="text-[#556B53] leading-7 mt-4">
                                Trusted sourcing with premium operational consistency.
                            </p>

                        </div>

                        {/* Card */}
                        <div className="bg-white rounded-[32px] p-7 border border-[#E2ECE2] shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300">

                            <div className="w-14 h-14 rounded-2xl bg-[#EAF2EA] text-[#88A77D] flex items-center justify-center">

                                <Package className="w-7 h-7" />

                            </div>

                            <h3 className="text-2xl font-black text-[#2C3E2B] mt-6">
                                Supply Systems
                            </h3>

                            <p className="text-[#556B53] leading-7 mt-4">
                                Efficient inventory and logistics management solutions.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* ================= CANADA SECTION ================= */}

            <section className="py-20 bg-[#EBF2EB] border-y border-[#D5E2D5]">

                <div className="max-w-[1700px] mx-auto px-5 lg:px-8">

                    <div className="grid lg:grid-cols-2 gap-16 items-center">

                        {/* Image */}
                        <div className="relative group overflow-hidden rounded-[36px]">

                            <img
                                src="https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?q=80&w=1200"
                                alt="Canada Operations"
                                className="rounded-[36px] shadow-2xl object-cover h-[420px] w-full transform group-hover:scale-105 transition duration-500"
                            />

                        </div>

                        {/* Content */}
                        <div>

                            <span className="bg-[#2C3E2B]/10 text-[#2C3E2B] text-xs font-bold uppercase tracking-[0.25em] px-5 py-3 rounded-full">

                                International Operations

                            </span>

                            <h2 className="text-4xl md:text-5xl font-black text-[#2C3E2B] mt-7 tracking-tight leading-tight">

                                Connecting India & Canada Through Hospitality Supply

                            </h2>

                            <p className="text-[#556B53] mt-6 leading-8 text-lg">

                                Through our Canadian arm,
                                <span className="font-bold text-[#2C3E2B]">
                                    {" "}ToGo Packaging Solutions
                                </span>
                                {" "}in Ottawa, CHEFCO bridges international
                                supply chains to provide seamless, efficient,
                                and scalable hospitality procurement solutions.

                            </p>

                            <p className="text-[#556B53] mt-5 leading-8 text-lg">

                                We combine chef-driven operational insight with
                                systematic logistics management to simplify sourcing,
                                inventory flow, and packaging procurement for
                                modern foodservice businesses.

                            </p>

                            {/* Ottawa/India Metrics info */}
                            <div className="grid grid-cols-2 gap-6 mt-8 pt-8 border-t border-[#D5E2D5]">
                                <div>
                                    <h4 className="font-black text-[#2C3E2B] text-lg">Ottawa Logistics</h4>
                                    <p className="text-sm text-[#556B53] mt-2">Serving Eastern Canada from our Ottawa-based warehousing hub.</p>
                                </div>
                                <div>
                                    <h4 className="font-black text-[#2C3E2B] text-lg">Sourcing Networks</h4>
                                    <p className="text-sm text-[#556B53] mt-2">Direct lines to premier manufacturing units across India.</p>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </div>

    );
};

export default WhyChefco;
